import * as React from 'react';
import { Sidebar } from './Sidebar';
import './DataflowViewer.css';
import { Graph } from './Graph';
/**
 * Wrap the component so we can catch the errors. We don't use the previously defined
 * error boundary component, since we want to seperate errors in graph generation from
 * errors in spec rendering
 * **/
export class DataflowViewer extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: null,
        };
    }
    componentDidCatch(error) {
        this.setState({ error });
    }
    render() {
        if (this.state.error) {
            return React.createElement("div", { id: "error-indicator" }, this.state.error.message);
        }
        return (React.createElement("div", { className: "dataflow-pane" },
            React.createElement(Sidebar, null),
            React.createElement(Graph, null)));
    }
}
